// src/portals/creator/pages/AdnakianGroupsPage.js
import React, { useState } from "react";
import Button from "../../../components/ui/Button";
import Card from "../../../components/ui/Card";
import { Plus, Users, Filter, Mail, Edit, Trash2 } from "lucide-react";

const AdnakianGroupsPage = () => {
  const [groups, setGroups] = useState([
    { id: 1, name: "Gold Tier Subscribers", count: 156, criteria: "Subscription = Gold", lastActive: "2 hrs ago" },
    { id: 2, name: "Big Spenders (>5000 ETB)", count: 45, criteria: "Total Spend > 5000", lastActive: "1 day ago" },
    { id: 3, name: "Concert Attendees", count: 320, criteria: "Purchased 'Unity Concert'", lastActive: "5 days ago" },
    { id: 4, name: "Inactive Fans (30 days)", count: 890, criteria: "Last Interaction > 30 days", lastActive: "N/A" },
  ]);

  return (
    <div className="space-y-6 max-w-full overflow-hidden">
      <div className="flex flex-col @md:flex-row justify-between items-start @md:items-center gap-4">
        <div>
           <h1 className="text-2xl @sm:text-3xl font-bold text-slate-800">Adnakian Groups</h1>
           <p className="text-slate-500 mt-1 text-sm @sm:text-base">Segment your audience into groups for targeted messaging and engagement.</p>
        </div>
        <Button className="w-full @md:w-auto"><Plus className="w-4 h-4 mr-2" /> Create Group</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {groups.map((group) => (
          <Card key={group.id} className="hover:shadow-md transition-shadow">
            <div className="flex justify-between items-start mb-4">
              <div className="p-3 bg-purple-50 text-purple-600 rounded-xl">
                <Users size={24} />
              </div>
              <div className="flex gap-2">
                <button className="text-slate-400 hover:text-slate-600"><Edit size={16} /></button>
                <button className="text-slate-400 hover:text-red-500"><Trash2 size={16} /></button>
              </div>
            </div>
            
            <h3 className="font-bold text-lg text-slate-800 mb-1">{group.name}</h3>
            <div className="flex items-center gap-2 text-sm text-slate-500 mb-4">
               <Filter size={14} /> {group.criteria}
            </div>
            
            <div className="flex justify-between items-center text-sm py-3 border-t border-slate-100 mb-4">
               <div>
                 <div className="font-bold text-slate-800">{group.count}</div>
                 <div className="text-slate-500 text-xs">Members</div>
               </div>
               <div className="text-right">
                 <div className="font-medium text-slate-800">{group.lastActive}</div>
                 <div className="text-slate-500 text-xs">Last Activity</div>
               </div>
            </div>
            
            <Button variant="outline" className="w-full">
              <Mail className="w-4 h-4 mr-2" /> Message Group
            </Button>
          </Card>
        ))}
        
        {/* Create New Placeholder */}
        <button className="border-2 border-dashed border-slate-200 rounded-xl flex flex-col items-center justify-center p-8 hover:border-purple-300 hover:bg-purple-50 transition-colors group h-full min-h-[250px]">
          <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-4 group-hover:bg-white group-hover:shadow-sm">
            <Plus className="w-6 h-6 text-slate-400 group-hover:text-purple-600" />
          </div>
          <h3 className="font-bold text-slate-600 group-hover:text-purple-700">Create Smart Group</h3>
          <p className="text-sm text-slate-400 text-center mt-2 px-4 group-hover:text-purple-600/70">
            Automatically group fans based on spending, activity, or subscription status.
          </p>
        </button>
      </div>
    </div>
  );
};

export default AdnakianGroupsPage;
